import React, { useState, useEffect, useRef } from "react";
// import {fileNameType} from "../../utils/helpers";
import Config from "../../Config.json";
// import Modal from '../module.modal';
// import Icons from '../module.icons';
// import Versions from '../module.versions';
import { apiCall } from "../narrativeUtils/fetch";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


function PageNotes(props) {



  function onNoteChange(value){
    const api_url = Config.baseURLcms + 'section-edit/';
    var dataJSON;
    dataJSON = {
      'id': props.activeSectionObj.id,
      'scroll_offset': props.activeSectionObj.scroll_offset,
      'title': props.activeSectionObj.title,
      'active': props.activeSectionObj.active,
      'notes': value,
      'force_version': false,
      'pip_loc': props.activeSectionObj.pip_loc
    }
    function responseTask(response) {
      // handleReloadSection(response);
    }
    apiCall('POST', api_url, dataJSON, responseTask, null, props.setFormError)

  }

    return(
       <div className="pageNotes">

            {props.activeSectionObj &&(
              <div className="settingsRow">
              <div className="sectionHeading" id={"section_" + props.activeSectionObj.id} key={'sectionHeading_' + props.activeSectionObj.id}>
              <div className="fieldRow">
                  <div className="errors"></div>
                    
                    <div className="groupLabel">PRESENTER NOTES</div>


                    
                    <CKEditor
                    editor={ ClassicEditor }
                    data={props.activeSectionObj.notes}
                    theme={'dark'}
                    config={{
                      toolbar: [ 'bold', 'italic', 'bulletedList', 'numberedList' ],
                      resize_enabled: true
                    }}
                    onReady={() => {
                      // tempTextObj.current = null;
                    }}
                    // onChange={ ( event, editor ) => {
                    //     const data = editor.getData();
                    //     console.log( { event, editor, data } );
                    //     onNoteChange(data)
                    // } }
                    onBlur={ ( event, editor ) => {
                      const data = editor.getData();
                      console.log( { event, editor, data } );
                      onNoteChange(data)
                  } }
                />
                  
                </div>
              
              </div>
              </div>
              )}

                     
      </div>
    )
}

export default PageNotes;